import EventEmitter from 'events';

// Standard observer pattern, the nudges will invoke this
// to change visibility of scroll element or scroll to the point

const ScrollUpdateEmitter = new EventEmitter();

export default ScrollUpdateEmitter;
